
import XButton from 'vux/src/components/x-button/index.vue'

import Divider from 'vux/src/components/divider/index.vue'

import Group from 'vux/src/components/group/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'


export default {
name: "SellerRechargeList",
components: {
Divider,
XButton,
Group,
Cell,
CellFormPreview
},
data() {
return {
clickId: 0,
isOpen: false,
list: []
}
},
created() {
this.$http.get(this.tianYiWebUrl + '/wechat/recharge/list')
.then(res => {
if (res.data.code === 200) {
this.list = res.data.data;
}
})
},
methods: {
clickColl(logId) {
if (logId !== this.clickId) {
this.clickId = logId;
this.isOpen = true;
} else {
this.isOpen = false;
this.clickId = 0;
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/SellerRechargeList.vue